import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

const KnowWho = () => {
  const { t } = useTranslation('common');

  const features = [
    {
      id: 1,
      title: t('Who unfollowed you?'),
      description: t(
        'Find out who stopped following you and when it happened—no more guessing who disappeared from your followers list.'
      ),
      image: '/images/unfollow/know-who-1.webp',
      bgColor: 'bg-gradient-to-b from-[#FCEFEF] to-white',
    },
    {
      id: 2,
      title: t("Who's Not Following You Back?"),
      description: t(
        "Find out who you're following but hasn't followed you back. Because not every follow is a two-way street."
      ),
      image: '/images/unfollow/know-who-2.webp',
      bgColor: 'bg-gradient-to-b from-[#E7F7FF] to-white',
    },
    {
      id: 3,
      title: t("Who's following you too?"),
      description: t(
        "Mutual connections show who's really in your circle. See who followed you back and focus on the followers that matter most."
      ),
      image: '/images/unfollow/know-who-3.webp',
      bgColor: 'bg-gradient-to-b from-[#E9FFE8] to-white',
    },
  ];

  return (
    <section className="py-16 max-md:px-6">
      <h2 className="text-center text-3xl font-bold mb-14 max-md:mb-9">{t("Know Who's Following, and Who's Not")}</h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-md:gap-5">
        {features.map((feature) => (
          <div key={feature.id} className={`${feature.bgColor} rounded-lg p-6 flex flex-col border border-[#E3E3E3]`}>
            <div className="w-[140px] h-[140px] relative rounded-lg flex items-center justify-center mb-8 max-md:w-[84px] max-md:h-[84px] max-md:mb-5">
              <Image src={feature.image} alt={feature.title} width={140} height={140} className="object-contain" />
            </div>
            <h3 className="text-[18px] leading-[25px] font-bold mb-3 max-md:text-[16px] max-md:leading-[22px]">
              {feature.title}
            </h3>
            <p className="text-base leading-[22px] text-[#6d6d6d] max-md:text-sm">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default KnowWho;
